function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none"
    },
    d: "M149.8,171.7H19.5c-3.8,0-6.8,3.1-6.8,6.8s3.1,6.8,6.8,6.8h130.3c3.8,0,6.8-3.1,6.8-6.8 S153.6,171.7,149.8,171.7z M102.4,83.8l38.2-33c2.9-2.5,3.2-6.8,0.7-9.6c-2.5-2.9-6.8-3.2-9.6-0.7L99.7,68.1c-1,0.9-2.6,0.9-3.6,0 L80.1,54.2c-2.6-2.2-6.4-2.2-8.9,0L41.3,79.9c-2.9,2.5-3.2,6.8-0.7,9.6c2.5,2.9,6.8,3.2,9.6,0.7L73.8,70c1-0.9,2.6-0.9,3.6,0 l16.1,13.9C96,86.1,99.8,86.1,102.4,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M19.5,182.6c-2.2,0-4-1.8-4-4s1.8-4,4-4h130.3c2.2,0,4,1.8,4,4s-1.8,4-4,4H19.5z M45.8,89.1 c-1.2,0-2.3-0.5-3-1.4c-1.4-1.7-1.3-4.2,0.4-5.7L73,56.3c0.7-0.6,1.7-1,2.6-1c1,0,1.9,0.3,2.6,1l16.1,13.9c1,0.9,2.3,1.4,3.7,1.4 s2.6-0.5,3.7-1.4l31.9-27.6c0.7-0.6,1.7-1,2.6-1c1.2,0,2.3,0.5,3,1.4c1.4,1.7,1.3,4.2-0.4,5.7l-38.2,33c-0.7,0.6-1.7,1-2.6,1 s-1.9-0.3-2.6-1L79.3,67.8c-1-0.9-2.3-1.4-3.7-1.4S73,66.9,72,67.8L48.4,88.1C47.7,88.8,46.8,89.1,45.8,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none"
    },
    d: "M184.2,166.7l-16.3-16.3c5.8-7.3,8.9-16.3,8.9-25.8c0-0.7,0-1.3-0.1-2h0.1V26.5 c0-7.1-5.8-12.9-12.9-12.9H26.5c-7.1,0-12.9,5.8-12.9,12.9v107.1c0,7.1,5.8,12.9,12.9,12.9h73.4c7.3,11.9,20.5,19.8,35.4,19.8 c8.1,0,15.9-2.3,22.6-6.6l16.8,16.8c2.7,2.7,7,2.7,9.7,0C186.9,173.7,186.9,169.4,184.2,166.7z M27.2,132.8V27.2h136v66.7 c-7.4-6.8-17.2-10.9-28-10.9c-22.9,0-41.6,18.7-41.6,41.6c0,2.8,0.3,5.5,0.8,8.1H27.2z M135.2,152.6c-15.4,0-27.9-12.5-27.9-27.9 s12.5-27.9,27.9-27.9s27.9,12.5,27.9,27.9S150.6,152.6,135.2,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M179.4,175.6c-1.1,0-2.1-0.4-2.8-1.2L158.2,156l-1.9,1.2c-6.3,4-13.5,6.2-21,6.2 c-13.5,0-25.9-6.9-33-18.5l-0.8-1.3H26.5c-5.5,0-10.1-4.5-10.1-10.1V26.5c0-5.5,4.5-10.1,10.1-10.1H164c5.5,0,10.1,4.5,10.1,10.1 v93.3h-0.3l0.2,3c0,0.6,0.1,1.2,0.1,1.9c0,8.9-2.9,17.2-8.3,24l-1.6,2l18.1,18.1c1.6,1.6,1.6,4.1,0,5.7 C181.5,175.2,180.5,175.6,179.4,175.6z M135.2,93.9c-17,0-30.8,13.8-30.8,30.8s13.8,30.8,30.8,30.8s30.8-13.8,30.8-30.8 S152.2,93.9,135.2,93.9z M24.4,135.6h73.5l-0.7-3.4c-0.5-2.5-0.7-5-0.7-7.6c0-21.4,17.4-38.8,38.8-38.8c9.7,0,19,3.6,26.1,10.2 l4.7,4.3V24.4H24.4V135.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.d213d260a2d368ecbd20d39a28a750e8.svg";
export { ForwardRef as ReactComponent };